import { createCartHandoff } from './marinas-cart-handoff-auto-v1.js';

// Keep theme presentation and Shopify line properties intact. Only the normal
// cart checkout action is routed through the existing authenticated handoff.
const config = document.getElementById('marinas-theme-bridge');
if (config && config.dataset.designMode !== 'true') {
  const root = config.dataset.cartRoot || '/';
  const client = createCartHandoff({ proxy: config.dataset.proxyPath, root });
  const scopes = new WeakSet();
  let busy = false, revision = 0, changingNode = null;
  const containers = '#ns-hybrid-cart, .replica-cart, .ag-drawer, #ag-cart-page, #NativeCart, form[action*="/cart"]';
  const inputs = 'input[data-audit-cart-quantity], input[data-cart-id], input[name="updates[]"], [data-marinas-quantity]';
  const accelerated = '.shopify-payment-button,.additional-checkout-buttons,shopify-accelerated-checkout,shopify-accelerated-checkout-cart';
  function normalButton(node) {
    if (!(node instanceof Element) || node.closest(accelerated)) return null;
    const button = node.closest('button[name="checkout"],input[name="checkout"],a[href]');
    if (!button || !button.closest(containers)) return null;
    if (button.matches('a')) {
      const url = new URL(button.href, location.href);
      if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout\/?$/.test(url.pathname) || url.search || url.hash) return null;
    }
    return button;
  }
  function quantities(container) {
    const values = [...container.querySelectorAll(inputs)].map(input => Number(input.value));
    return values.length ? values : [...container.querySelectorAll('.replica-quantity > span')].map(node => Number(node.textContent));
  }
  function notice(button, message) {
    let status = button.parentElement.querySelector('[data-marinas-bridge-status]');
    if (!status) { status = document.createElement('p'); status.dataset.marinasBridgeStatus = ''; status.setAttribute('role','status'); status.setAttribute('aria-live','polite'); button.parentElement.append(status); }
    status.textContent = message;
  }
  async function checkout(button) {
    const container = button.closest('#ns-hybrid-cart, .replica-cart, .ag-drawer, #ag-cart-page, #NativeCart') || button.closest('form[action*="/cart"]');
    if (busy || button.matches(':disabled') || container?.getAttribute('aria-busy') === 'true') return;
    if (changingNode?.isConnected) { notice(button,'Please finish updating your cart before checking out.'); return; }
    const expected = quantities(container), start = revision;
    if (!expected.length || expected.some(value=>!Number.isSafeInteger(value)||value<1||value>20)) { notice(button,'Please finish updating your cart before checking out.'); return; }
    busy = true; button.setAttribute('aria-busy','true');
    notice(button,'Preparing your secure checkout…');
    try {
      const response = await fetch(root + 'cart.js', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(15000)});
      if (!response.ok) throw Error('The cart could not be checked. Please try again.');
      const cart = await response.json();
      if (!Array.isArray(cart.items) || cart.items.length !== expected.length || cart.items.some((item,i)=>item.quantity!==expected[i])) throw Error('Your cart is updating. Please review it and try again.');
      // Preserve existing native subscriptions until their exact terms have
      // been imported and independently verified in Marinas.
      if (cart.items.some(item=>item.selling_plan_allocation)) {
        if (config.dataset.nativeSubscriptions !== 'preserve') throw Error('Subscription checkout is being connected. Please contact the store.');
        if (start===revision && button.isConnected) location.assign(root+'checkout');
        return;
      }
      const destination = await client.start(expected, {requiredCapabilities:['productionCheckoutSupported','shippingSupported']});
      if (start !== revision || !button.isConnected || JSON.stringify(quantities(container)) !== JSON.stringify(expected)) throw Error('Your cart changed. Please review it and select Checkout again.');
      location.assign(destination);
    } catch(error) { if(button.isConnected) notice(button,error instanceof Error?error.message:'Checkout is unavailable. Please try again.'); }
    finally { busy=false;button.removeAttribute('aria-busy'); }
  }
  function onClick(event) {
    const path = event.composedPath();
    const element = path.find(node=>node instanceof Element);
    if (!element) return;
    const mutation = element.closest('[data-cart-id],[data-remove],[data-key],[data-audit-cart-action="plus"],[data-audit-cart-action="minus"],[data-audit-cart-action="remove"]');
    if (mutation?.closest(containers) && !mutation.matches('input')) { revision++; changingNode=mutation; }
    const button = normalButton(element);
    if (!button) return;
    event.preventDefault();event.stopImmediatePropagation();void checkout(button);
  }
  function attach(scope) {
    if (scopes.has(scope)) return;
    scopes.add(scope);
    scope.addEventListener('submit', event=>{
      const button=normalButton(event.submitter);
      if(!button) return;
      event.preventDefault();event.stopImmediatePropagation();void checkout(button);
    }, true);
    scope.addEventListener('change', event=>{if(event.target instanceof Element&&event.target.matches(inputs)){revision++;changingNode=event.target;}},true);
    const scan=()=>{scope.querySelectorAll('#audit-native-source-cart').forEach(node=>{if(node.shadowRoot)attach(node.shadowRoot);});};
    new MutationObserver(scan).observe(scope,{childList:true,subtree:true});scan();
  }
  window.addEventListener('click',onClick,true);
  attach(document);
}
